import { SVGProps } from 'react'

export const WifiIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={70}
		height={54}
		viewBox="0 0 70 54"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M39.717 51.658a6.65 6.65 0 0 0 0-9.42 6.647 6.647 0 0 0-9.427-.006 6.667 6.667 0 1 0 9.427 9.426m23.57-26.323a6.64 6.64 0 0 1-4.714-1.953c-12.996-12.997-34.143-12.994-47.143 0A6.668 6.668 0 1 1 2 13.952c18.197-18.194 47.803-18.194 65.997 0a6.667 6.667 0 0 1-4.71 11.383M20.86 39.475a6.668 6.668 0 0 1-4.713-11.38c10.393-10.397 27.313-10.397 37.71 0a6.668 6.668 0 1 1-9.43 9.43 13.35 13.35 0 0 0-18.857 0 6.63 6.63 0 0 1-4.71 1.95"
			fill="#CDD0DB"
		/>
	</svg>
)
